export const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen pb-20">
      {/* Hero */}
      <section className="pt-24 lg:pt-32 pb-10 bg-muted/30">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl font-display font-bold mb-4">
            Privacy Policy
          </h1>
          <p className="text-sm text-muted-foreground">
            Last updated: February 2026
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="pt-10">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none space-y-8">
          <section>
            <h2 className="text-2xl font-display font-semibold mb-4">Introduction</h2>
            <p className="text-foreground leading-relaxed">
              Evolution GEO ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-display font-semibold mb-4">Information We Collect</h2>
            <p className="text-foreground leading-relaxed mb-4">
              We collect information that you provide directly to us, including:
            </p>
            <ul className="list-disc list-inside space-y-2 text-foreground">
              <li>Name and contact information (email, phone number)</li>
              <li>Company name and website URL</li>
              <li>Industry and business information</li>
              <li>Communications and correspondence with us</li>
              <li>Information submitted through forms on our website (including the Contact form and Free GEO/AIO Audit form)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-display font-semibold mb-4">Forms, Turnstile &amp; Communications</h2>
            <p className="text-foreground leading-relaxed mb-4">
              Our Contact form and Free GEO/AIO Audit form are protected by Cloudflare Turnstile to help prevent automated and abusive submissions.
              When you submit either form, Cloudflare may process certain technical data to validate that you are a genuine user. You can learn more in Cloudflare&apos;s own privacy documentation.
            </p>
            <p className="text-foreground leading-relaxed mb-4">
              By submitting your details through these forms, you consent to us using your contact information to:
            </p>
            <ul className="list-disc list-inside space-y-2 text-foreground mb-4">
              <li>Respond to your enquiry or deliver your GEO/AIO audit</li>
              <li>Send reasonable follow-up emails related to your request</li>
              <li>Occasionally share relevant updates about Evolution GEO services</li>
            </ul>
            <p className="text-foreground leading-relaxed">
              You can opt out of non-essential marketing communications at any time by using the unsubscribe option in our emails or by contacting us directly.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-display font-semibold mb-4">How We Use Your Information</h2>
            <p className="text-foreground leading-relaxed mb-4">
              We use the information we collect to:
            </p>
            <ul className="list-disc list-inside space-y-2 text-foreground">
              <li>Provide and improve our services</li>
              <li>Respond to your inquiries and fulfill your requests</li>
              <li>Send you marketing communications (with your consent)</li>
              <li>Analyze and improve our website and services</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-display font-semibold mb-4">Analytics &amp; Microsoft Clarity</h2>
            <p className="text-foreground leading-relaxed mb-4">
              We use analytics tools, including Microsoft Clarity, to understand how visitors use our website. These tools may collect information such as the pages you visit, where you click, your device and browser type, and other usage data.
            </p>
            <p className="text-foreground leading-relaxed mb-4">
              Microsoft Clarity uses cookies and similar technologies to collect this information and provides us with aggregated insights so we can improve usability and content. Data collected through Clarity may be linked to a pseudonymous identifier but is not used by us to personally identify you.
            </p>
            <p className="text-foreground leading-relaxed">
              You can learn more about how Microsoft processes data in the Microsoft Privacy Statement and adjust your browser settings if you wish to limit or block cookies.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-display font-semibold mb-4">Information Sharing</h2>
            <p className="text-foreground leading-relaxed">
              We do not sell your personal information. We may share your information with service providers who assist us in operating our website and conducting our business, subject to confidentiality obligations.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-display font-semibold mb-4">Data Security</h2>
            <p className="text-foreground leading-relaxed">
              We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-display font-semibold mb-4">Your Rights</h2>
            <p className="text-foreground leading-relaxed mb-4">
              Depending on your location, you may have certain rights regarding your personal information, including:
            </p>
            <ul className="list-disc list-inside space-y-2 text-foreground">
              <li>Access to your personal information</li>
              <li>Correction of inaccurate information</li>
              <li>Deletion of your information</li>
              <li>Objection to processing</li>
              <li>Data portability</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-display font-semibold mb-4">Contact Us</h2>
            <p className="text-foreground leading-relaxed">
              If you have questions about this Privacy Policy or our privacy practices, please contact us at:
              <br />
              <a href="mailto:privacy@evolutiongeo.com" className="text-primary hover:underline">
                privacy@evolutiongeo.com
              </a>
            </p>
          </section>
        </div>
        </div>
      </section>
    </div>
  );
};
